import { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, Col, FormGroup, Input, Modal, ModalBody, ModalHeader, Row, Table, } from "reactstrap";
import fileDownload from 'js-file-download';

import { API_ENDPOINTS } from "../api";
import { start } from "service";
import { BackgroundColorContext } from 'contexts/BackgroundColorContext';
import { INPUT } from 'Auth/config';
import { CabeceraFormulariosTratamiento, InputUsuario, Select1Aux, Select1, InputUsuarioXS, CabeceraFormulariosTratamientoLista, } from '../input/elementos';
import { saveDB } from 'service';
import toast from 'react-hot-toast';
import { editDB } from 'service';
import { eliminarDB } from 'service';
import { tratamientoPdf } from 'pdfMake/tratamiento';
import { ComponenteInputBuscar_, } from '../input/elementos';
import { buscarDB } from 'service';
import { faEdit, faEye,  faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



export default function Tratamiento() {     

  useEffect(() => {
    const ini = () => {
      document.title = "TRATAMIENTO";
      listar()
    }
    ini()
    return () => { }
  }, []);

  const [inputBuscar, setInputBuscar] = useState({ campo: null, valido: null })


  const [lista, setLista] = useState([])
  const [listaDepto, setListaDepto] = useState([])
  const [listaPacientes, setListaPacientes] = useState([])
  const [listaSuspension, setListaSuspension] = useState([])
  const [listaAbandono, setListaAbandono] = useState([])
  const [listaHospital, setListaHospital] = useState([])
  const [modalRegistrar, setModalRegistrar] = useState(false)
  const [modalEdit, setModalEdit] = useState(false)

  const [fechaInicio, setFechaInicio] = useState({ campo: null, valido: null })
  const [fechaConclusion, setFechaConclusion] = useState({ campo: null, valido: null })

  const [id, setId] = useState({ campo: null, valido: null })
  const [hospital, setHospital] = useState({ campo: null, valido: null })
  const [idHospital, setIdHospital] = useState({ campo: null, valido: null })
  const [idSuspension, setIdSuspension] = useState({ campo: null, valido: null })
  const [suspension, setSuspension] = useState({ campo: null, valido: null })
  const [idAbandono, setIdAbandono] = useState({ campo: null, valido: null })
  const [abandono, setAbandono] = useState({ campo: null, valido: null })
  const [observacion, setObservacion] = useState({ campo: null, valido: null })
  const [epidemica, setEpidemica] = useState({ campo: null, valido: null })
  const [rociado, setRociado] = useState({ campo: null, valido: null })
  const [complementarios, setComplementarios] = useState({ campo: null, valido: null })


  const [peso, setPeso] = useState({ campo: null, valido: null })
  const [ta, setTa] = useState({ campo: null, valido: null })
  const [temperatura, setTemperatura] = useState({ campo: null, valido: null })
  const [frecuencia, setFrecuencia] = useState({ campo: null, valido: null })

  const [estadoEnvio, setEstadoEnvio] = useState(0);

  const [idPaciente, setIdPaciente] = useState({ campo: null, valido: null });
  const [nombrePaciente, setNombrePaciente] = useState({ campo: null, valido: null });


  const [idPreQuirurgico, setIdPreQuirurgico] = useState({ campo: null, valido: null });
  const [preQuirurgico, setPreQuirurgico] = useState({ campo: null, valido: null });
  const [idPostTratamiento, setIdPostTratamiento] = useState({ campo: null, valido: null });
  const [postTratamiento, setPostTratamiento] = useState({ campo: null, valido: null });


  // consultas

  const [listaMedicamentos, setListaMedicamentos] = useState([])
  const [listaMujeresTratamiento, setListaMujeresTratamiento] = useState([])
  const [listaReacionDermatologica, setListaReacionDermatologica] = useState([])
  const [listaReaccionDigestiva, setListaReaccionDigestiva] = useState([])
  const [listaReaccionNeurologica, setListaReaccionNeurologica] = useState([])
  const [listaReaccionHematologica, setListaReaccionHematologica] = useState([])

  const [idMedicamento, setIdMedicamento] = useState({ campo: null, valido: null })
  const [medicamento, setMedicamento] = useState({ campo: null, valido: null })

  const [idReaccionDermatologica, setIdReaccionDermatologica] = useState({ campo: null, valido: null })
  const [reaccionDermatologica, setReaccionDermatologica] = useState({ campo: null, valido: null })
  const [idReaccionDigestiva, setIdReaccionDigestiva] = useState({ campo: null, valido: null })
  const [reaccionDigestiva, setReaccionDigestiva] = useState({ campo: null, valido: null })
  const [idReaccionNeurologica, setIdReaccionNeurologica] = useState({ campo: null, valido: null })
  const [reaccionNeurologica, setReaccionNeurologica] = useState({ campo: null, valido: null })
  const [idReaccionHematologica, setIdReaccionHematologica] = useState({ campo: null, valido: null })
  const [reaccionHematologica, setReaccionHematologica] = useState({ campo: null, valido: null })
  const [dosis, setDosis] = useState({ campo: null, valido: null })





  useEffect(() => {
    if (inputBuscar.campo?.length === 0) listar()
  }, [inputBuscar])

  const listar = async () => {
    const data = await start(API_ENDPOINTS.TRATAMIENTO.LISTAR,)
    setLista(data)
  };

  const listarParametros = async () => {
    try {
      const loadingToast = toast.loading('Cargando parámetros...');
      const data = await start(API_ENDPOINTS.TRATAMIENTO.LISTAR_PARAMETROS)
      toast.dismiss(loadingToast);

      if (data[0]?.length > 0) {
        setListaPacientes(data[0])
      }
      if (data[1]?.length > 0) {
        setListaSuspension(data[1])
      }
      if (data[2]?.length > 0) {
        setListaAbandono(data[2])
      }
      if (data[3]?.length > 0) {
        setListaHospital(data[3])
      }
      if (data[4]?.length > 0) {
        setListaDepto(data[4])
      }
      if (data[5]?.length > 0) {
        setListaMedicamentos(data[5])
      }
      if (data[6]?.length > 0) {
        setListaMujeresTratamiento(data[6])
      }
      if (data[7]?.length > 0) {
        setListaReacionDermatologica(data[7])
      }
      if (data[8]?.length > 0) {
        setListaReaccionDigestiva(data[8])
      }
      if (data[9]?.length > 0) {
        setListaReaccionNeurologica(data[9])
      }
      if (data[10]?.length > 0) {
        setListaReaccionHematologica(data[10])
      }
    } catch (error) {
      toast.error("Error al obtener las fichas")
    }
  };
  const opciones = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  const initialFormState = {
    campo: null,
    valido: null
  };
  const vaciarDatos = () => {
    const fieldsToReset = {
      setIdSuspension,
      setSuspension,
      setIdAbandono,
      setAbandono,
      setObservacion,
      setEpidemica,
      setComplementarios,  
      setHospital,
      setIdHospital
    };
    Object.values(fieldsToReset).forEach(setterFn => {
      setterFn(initialFormState);
    });

    setModalEdit(false);
    setModalRegistrar(false);
  };


  const buscar = async () => {
    if (inputBuscar.valido === "true") {
      const data = await buscarDB(API_ENDPOINTS.TRATAMIENTO.BUSCAR, { dato: inputBuscar.campo })
      if (data.length == 0) toast.error("No se encontraron registros")

      setLista(data)
    }
  }

  const insertar = async () => {
    if (estadoEnvio === 0) {
      setEstadoEnvio(1);
      await saveDB(API_ENDPOINTS.TRATAMIENTO.REGISTRAR, {

        // DATOS PACIENTE
        id_paciente: idPaciente.campo,
        nombre_paciente: listaPacientes.find(e => idPaciente.campo == e.value)?.label,
        fecha_inicio: fechaInicio.campo,
        fecha_conclusion: fechaConclusion.campo,

        //REACCIONES ADVERSAS
        idReaccionDermatologica: idReaccionDermatologica.campo,
        reaccionDermatologica: reaccionDermatologica.campo,
        idReaccionDigestiva: idReaccionDigestiva.campo,
        reaccionDigestiva: reaccionDigestiva.campo,
        idReaccionNeurologica: idReaccionNeurologica.campo,
        reaccionNeurologica: reaccionNeurologica.campo,
        idReaccionHematologica: idReaccionHematologica.campo,
        reaccionHematologica: reaccionHematologica.campo,

        // OTRA INFORMACION
        epidemica: epidemica.campo,
        rociado:rociado.campo,
        complementarios: complementarios.campo,

        peso: peso.campo,
        ta: ta.campo,
        temperatura: temperatura.campo,
        frecuencia: frecuencia.campo,

        idMedicamento: idMedicamento.campo,
        medicamento: medicamento.campo,
        dosis: dosis.campo,
        // idMujeresTratamiento: idMujeresTratamiento.campo,
        // mujeresTratamiento: mujeresTratamiento.campo,
        idSuspension: idSuspension.campo,
        suspension: suspension.campo,
        idAbandono: idAbandono.campo,
        abandono: abandono.campo,
        idHospital: idHospital.campo, // hospital de referencia,
        hospital: hospital.campo,
        // id_pre_quirurgico: idPreQuirurgico.campo,
        // pre_quirurgico: preQuirurgico.campo,
        id_post_tratamiento: idPostTratamiento.campo,
        post_tratamiento: postTratamiento.campo,
        // id_estado_mujeres: idEstadoMujeres.campo,
        // estado_mujeres: estadoMujeres.campo,
        observacion: observacion.campo,
      }, setModalRegistrar, setEstadoEnvio, false, vaciarDatos)
      listar()
    } else toast.error("FORMULARIO YA ENVIADO");
  };

  const editar = async () => {
    await editDB(API_ENDPOINTS.TRATAMIENTO.MODIFICAR, {
      id: id.campo,

      // DATOS PACIENTE
      id_paciente: idPaciente.campo,
      nombre_paciente: nombrePaciente.campo,
      fecha_inicio: fechaInicio.campo,
      fecha_conclusion: fechaConclusion.campo,

      //REACCIONES ADVERSAS
      idReaccionDermatologica: idReaccionDermatologica.campo,
      reaccionDermatologica: reaccionDermatologica.campo,
      idReaccionDigestiva: idReaccionDigestiva.campo,
      reaccionDigestiva: reaccionDigestiva.campo,
      idReaccionNeurologica: idReaccionNeurologica.campo,
      reaccionNeurologica: reaccionNeurologica.campo,
      idReaccionHematologica: idReaccionHematologica.campo,
      reaccionHematologica: reaccionHematologica.campo,

      // OTRA INFORMACION
      epidemica: epidemica.campo,
      rociado:rociado.campo,
      complementarios: complementarios.campo,   
      idMedicamento: idMedicamento.campo,
      medicamento: medicamento.campo,
      dosis: dosis.campo,        

      peso: peso.campo,
      ta: ta.campo,
      temperatura: temperatura.campo,
      frecuencia: frecuencia.campo,

      idSuspension: idSuspension.campo,
      suspension: suspension.campo,
      idAbandono: idAbandono.campo,
      abandono: abandono.campo,
      idHospital: idHospital.campo, // hospital de referencia,
      hospital: hospital.campo,
      // id_pre_quirurgico: idPreQuirurgico.campo,
      // pre_quirurgico: preQuirurgico.campo,
      id_post_tratamiento: idPostTratamiento.campo,
      post_tratamiento: postTratamiento.campo,
      // idMujeresTratamiento: idMujeresTratamiento.campo,
      // mujeresTratamiento: mujeresTratamiento.campo,
      // id_estado_mujeres: idEstadoMujeres.campo,
      // estado_mujeres: estadoMujeres.campo,
      observacion: observacion.campo,
    }, setModalEdit, false, vaciarDatos)
    listar()
  };


  const eliminar = async (tratamiento) => {
    if (window.confirm('Eliminar Tratamiento ?')) {
      await eliminarDB(API_ENDPOINTS.TRATAMIENTO.ELIMINAR, { tratamiento })
      listar()
    }
  }

  const exportPdf = async (output, tratamiento, paciente) => {
    const data = await start(API_ENDPOINTS.TRATAMIENTO.VER_PDF, {tratamiento, paciente })


    const response = await tratamientoPdf(output, { paciente: data[0], listaTratamiento: data[1]})

    if (!response?.success) {
      alert(response?.message);
      return;
    }

    if (output === "b64") {
      const b64toBlob = (
        b64Data,
        contentType = "",
        sliceSize = 512
      ) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (
          let offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          const slice = byteCharacters.slice(
            offset,
            offset + sliceSize
          );

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      };
      const blob = b64toBlob(response.content, "application/pdf");
      fileDownload(blob, "Ficha-Epidemiologica.pdf");
    }
  }

  return (
    < >

      <div className="contentSimple" >
        <div className="main-container">
          <Card>

            <CabeceraFormulariosTratamientoLista text={"LISTA DE TRATAMIENTO PARA CHAGAS"} />

            <CardBody style={{ paddingTop: "5px" }}>

              <div style={{ display: 'flex', justifyContent: 'end' }}>
                <button className='btn-new-transparent' pb={3} onClick={() => { setModalRegistrar(true); listarParametros() }} >
                  Registrar
                </button >
              </div>
              <div className="pt-2 pl-0">
                <ComponenteInputBuscar_
                  estado={inputBuscar}
                  cambiarEstado={setInputBuscar}
                  name="inputBuscar"
                  ExpresionRegular={INPUT.INPUT_BUSCAR}  //expresion regular
                  placeholder="Escriba para filtrar ..."
                  eventoBoton={buscar}
                  etiqueta={'Buscar'}
                />
              </div>

              <Table className="tablesorter" responsive >
                <BackgroundColorContext.Consumer>
                  {({ color }) => (
                    <thead className="text-primary" data={color}>
                      <tr >
                        <th >NOMBRE</th>
                        <th >APELLIDO PATERNO</th>
                        <th >APELLIDO MATERNO</th>
                        <th >CI</th>
                        <th >FECHA INICIO</th>
                        <th >FECHA CONCLUSION</th>
                        <th >ESTABLECIMIENTO</th>
                        <th >MEDICO</th>
                        <th ></th>
                      </tr>
                    </thead>
                  )}
                </BackgroundColorContext.Consumer>
                <tbody >
                  {lista.map((a, index) => (
                    <tr key={a.id} style={{
                      height: '50px', background: index % 2 == 0 ? "#E1EEF4" : 'white'
                    }} className='item'>
                      <td><div className="tbl-des">{a.nombre}</div></td>
                      <td><div className="tbl-des">{a.ap1}</div></td>
                      <td><div className="tbl-des">{a.ap2}</div></td>
                      <td><div className="tbl-des">{a.ci}</div></td>
                      <td><div className="tbl-des">{a.fecha_inicio}</div></td>
                      <td><div className="tbl-des">{a.fecha_conclusion}</div></td>
                      <td><div className="tbl-des">{a.hospital}</div></td>
                      <td><div className="tbl-des">{a.usuario}</div></td>
                      <td>
                        <div className="row btn-tbl-container ">

                          {a.edicion ?
                            <>
                              <div

                                className="btn-tbl col-3 bg-info"
                                onClick={() => {
                                  setId({ campo: a.id_tratamiento, valido: true })
                                  setIdPaciente({ campo: a.id_paciente, valido: true })
                                  setNombrePaciente({ campo: a.nombre, valido: true })
                                  setFechaInicio({ campo: a.fecha_inicio, valido: true })
                                  setFechaConclusion({ campo: a.fecha_conclusion, valido: true })
                                  setIdReaccionDermatologica({ campo: a.idReaccionDermatologica, valido: true })
                                  setReaccionDermatologica({ campo: a.reaccionDermatologica, valido: true })
                                  setIdReaccionDigestiva({ campo: a.idReaccionDigestiva, valido: true })
                                  setReaccionDigestiva({ campo: a.reaccionDigestiva, valido: true })
                                  setIdReaccionNeurologica({ campo: a.idReaccionNeurologica, valido: true })
                                  setReaccionNeurologica({ campo: a.reaccionNeurologica, valido: true })
                                  setIdReaccionHematologica({ campo: a.idReaccionHematologica, valido: true })
                                  setEpidemica({ campo: a.epidemica, valido: true })
                                  setRociado({campo:a.rociado, valido: true })
                                  setComplementarios({ campo: a.complementarios, valido: true })

                                  setPeso({ campo: a.peso, valido: true })
                                  setTa({ campo: a.presion_arterial, valido: true })
                                  setTemperatura({ campo: a.temperatura, valido: true })
                                  setFrecuencia({ campo: a.f_cardiaca, valido: true })


                                  setIdMedicamento({ campo: a.idMedicamento, valido: true })
                                  setMedicamento({ campo: a.medicamento, valido: true })
                                  setDosis({ campo: a.dosis, valido: true })

                                  setIdSuspension({ campo: a.idSuspension, valido: true })
                                  setSuspension({ campo: a.suspension, valido: true })
                                  setIdAbandono({ campo: a.idAbandono, valido: true })
                                  setAbandono({ campo: a.abandono, valido: true })
                                  setIdHospital({ campo: a.id_hospital_ref, valido: true })
                                  setHospital({ campo: a.hospital_ref, valido: true })
                                  setIdPreQuirurgico({ campo: a.id_pre_quirurgico, valido: true })
                                  setPreQuirurgico({ campo: a.pre_quirurgico, valido: true })
                                  setIdPostTratamiento({ campo: a.id_post_tratamiento, valido: true })
                                  setPostTratamiento({ campo: a.post_tratamiento, valido: true })

                                  setObservacion({ campo: a.observacion, valido: true })
                                  listarParametros()
                                  setModalEdit(true)
                                }}
                              ><FontAwesomeIcon icon={faEdit}></FontAwesomeIcon></div>
                              <div
                                onClick={() => eliminar(a.id_tratamiento)}
                                className="btn-tbl col-3  ml-1" style={{ background: '#FF3D85' }}><FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                              </div>
                            </> : null
                          }

                          {a.id_tratamiento > 0 ?
                            < div onClick={() => { exportPdf(window.innerWidth < 1100 ? 'b64' : "print", a.id_tratamiento, a.id_paciente) }}
                              className="btn-tbl btn-success col-3  ml-1 " style={{ background: '#00d084' }} ><FontAwesomeIcon icon={faEye}></FontAwesomeIcon></div> : null}
                        </div>    
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {lista.length < 1 && (
                <div class="text-success text-center" style={{ fontSize: "18px" }}>Lista Vacia</div>
              )}
            </CardBody>
          </Card>
        </div>
      </div >


      <Modal
        isOpen={modalRegistrar}
        toggle={() => setModalRegistrar(!modalRegistrar)}
        className="modal-lgmd"
      >
        <ModalHeader
          toggle={() => setModalRegistrar(!modalRegistrar)}
        ></ModalHeader>
        <ModalBody>

          <CabeceraFormulariosTratamiento text={'NUEVO TRATAMIENTO'} />
       

          <div className='cabecera-form mt-3'  >
            <p>DATOS DEL PACIENTE</p>
          </div>
          <Row className='mb-3'>
            <Col md={4}>
              <Select1
                estado={idPaciente}
                cambiarEstado={setIdPaciente}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Paciente'}
                msg={"el formato no es valido"}
                lista={listaPacientes}
                name={'id_paciente'}
                label={setNombrePaciente}
                importante={false}
              />
            </Col>

            <Col md={3}>
              <FormGroup>
                <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                  {'Paciente'}
                </label>
                <Input
                  type="text"
                  value={listaPacientes.find(e => idPaciente.campo == e.value)?.label?.split('-')[0] || ""}
                  valido={null}
                  placeholder={'PACIENTE'}
                  toUpperCase
                  disabled
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                  {'Cédula de identidad'}
                </label>
                <Input
                  type="text"
                  value={listaPacientes.find(e => idPaciente.campo == e.value)?.ci || ""}
                  valido={null}
                  placeholder={'C.I.'}
                  toUpperCase
                  disabled
                />
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup>
                <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                  {'fecha Nacimiento'}
                </label>
                <Input
                  type="text"
                  value={listaPacientes.find(e => idPaciente.campo == e.value)?.fecha_nac || ""}
                  valido={null}
                  placeholder={'FECHA NACIMIENTO'}
                  toUpperCase
                  disabled
                />
              </FormGroup>
            </Col>
          </ Row>


          <div className='cabecera-form mt-3'  >
            <p>RESULTADOS</p>
          </div>
          <Row>
            <Col md={4}>
              <Select1
                estado={epidemica}
                cambiarEstado={setEpidemica}
                name={'epidemica'}
                ExpresionRegular={INPUT.ID}
                lista={[ {value:1, label:'VIVIENDA NEGATIVA'}, {value:2, label:'VIVIENDA POSITIVA'} ]}
                etiqueta={'Situacion epidemica'}
                msg={"El formato no es válido"}
              />
            </Col>
            <Col md={4}>
              <Select1
                estado={rociado}
                cambiarEstado={setRociado}
                name={'rociado'}
                ExpresionRegular={INPUT.ID}
                lista={[ {value:1, label:'VIVIENDA ROCIADO'}, {value:2, label:'VIVIENDA NO ROCIADO'} ]}
                etiqueta={'Vivienda rociado'}
                msg={"El formato no es válido"}
              />
            </Col>


            <Col md={4}>
              <Select1Aux
                estado={idPostTratamiento}
                cambiarEstado={setIdPostTratamiento}
                ExpresionRegular={INPUT.ID}
                etiqueta={'PostTratamiento'}
                msg={"el formato no es valido"}
                lista={[{ value: 1, label: 'Si' }, { value: 2, label: 'No' }]}
                name={'id_post_tratamiento'}
                label={setPostTratamiento}
                importante={false}
              />
            </Col>
            <Col md={12}>
              <InputUsuario
                tipo='textarea'
                estado={complementarios}
                cambiarEstado={setComplementarios}
                name={'complementarios'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Resultados examenes complementarios'}
                msg={"El formato no es válido"}
                importante={false}
              />
            </Col>
          </Row>
          <div className='cabecera-form mt-3'  >
            <p>TRATAMIENTO</p>
          </div>

          <Row>
            <Col md={3}>
              <InputUsuario
                estado={peso}
                cambiarEstado={setPeso}
                name={'peso'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Peso (Kg.)'}
                msg={"El formato no es válido"}
              />
            </Col>
            <Col md={3}>
              <InputUsuario
                estado={ta}
                cambiarEstado={setTa}
                name={'presion_arterial'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'TA(mmHg)'}
                msg={"El formato no es válido"}
              />
            </Col>
            <Col md={3}>
              <InputUsuario
                estado={temperatura}
                cambiarEstado={setTemperatura}
                name={'temperatura'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Temperatura(°c)'}
                msg={"El formato no es válido"}
              />
            </Col>
            <Col md={3}>
              <InputUsuario
                estado={frecuencia}
                cambiarEstado={setFrecuencia}
                name={'frecuencia_cardiaca'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Frec. cardiaca(Ipm)'}
                msg={"El formato no es válido"}
              />
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Select1Aux
                estado={idMedicamento}
                name={'id_medicamento'}
                cambiarEstado={setIdMedicamento}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Medicamento'}
                lista={listaMedicamentos}
                msg={"el formato no es valido"}
                label={setMedicamento}
              />
            </Col>
            <Col md={3}>
              <InputUsuario
                estado={dosis}
                cambiarEstado={setDosis}
                name={'dosis'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Dosis Mg.'}
                msg={"El formato no es válido"}
              />
            </Col>

            <Col md={3}>
              <InputUsuario
                estado={fechaInicio}
                cambiarEstado={setFechaInicio}
                ExpresionRegular={INPUT.DATE} //expresion regular
                etiqueta={'Fecha inicio'}
                msg={"el formato no es valido"}
                name={'fecha_inicio'}
                tipo='date'
              />
            </Col>

            <Col md={3}>
              <InputUsuario
                estado={fechaConclusion}
                cambiarEstado={setFechaConclusion}
                ExpresionRegular={INPUT.DATE} //expresion regular
                etiqueta={'Fecha conclusion'}
                msg={"el formato no es valido"}
                name={'fecha_conclusion'}
                tipo='date'
                importante={false}
              />
            </Col>
          </Row>
          <Row>

            <Col md={2}>
              <Select1
                estado={idSuspension}
                cambiarEstado={setIdSuspension}
                ExpresionRegular={INPUT.ID} //expresion regular
                etiqueta={'Suspension'}
                lista={listaSuspension}
                name={'idSuspension'}
                label={setSuspension}
                importante={false}
              />
            </Col>
            <Col md={2}>
              <Select1
                estado={idAbandono}
                cambiarEstado={setIdAbandono}
                ExpresionRegular={INPUT.ID} //expresion regular
                etiqueta={'Abandono'}
                lista={listaAbandono}
                msg={"el formato no es valido"}
                name={'idAbandono'}
                label={setAbandono}
                importante={false}
              />
            </Col>


{/* 
            <Col md={4}>
              <Select1
                estado={idPreQuirurgico}
                cambiarEstado={setIdPreQuirurgico}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Prequirurgico'}
                msg={"el formato no es valido"}
                lista={[{ value: 1, label: 'Si' }, { value: 2, label: 'No' }]}
                name={'id_prequirurgico'}
                label={setPreQuirurgico}
                importante={false}
              />
            </Col> */}
            <Col md={4}>
              <Select1
                estado={idHospital}
                cambiarEstado={setIdHospital}
                ExpresionRegular={INPUT.ID} //expresion regular
                etiqueta={'Hospital de referencia'}
                lista={listaHospital}
                name={'hospital_ref'}
                label={setHospital}
                importante={false}
              />
            </Col>
          </Row>


          <div className='cabecera-form mt-3' >
            <p>REACCIONES ADVERSAS</p>
          </div>
          <Row className='mb-3'>
            <Col md={4}>
              <Select1
                estado={idReaccionDermatologica}
                cambiarEstado={setIdReaccionDermatologica}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Reacción Dermatológica'}
                msg={"el formato no es valido"}
                lista={listaReacionDermatologica}
                name={'id_reaccion_dermatologica'}
                label={setReaccionDermatologica}
                importante={false}

              />
            </Col>
            <Col md={3}>
              <Select1
                estado={idReaccionDigestiva}
                cambiarEstado={setIdReaccionDigestiva}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Reacción Digestiva'}
                lista={listaReaccionDigestiva}
                msg={"el formato no es valido"}
                name={'id_reaccion_digestiva'}
                label={setReaccionDigestiva}
                importante={false}

              />
            </Col>

            <Col md={3}>
              <Select1
                estado={idReaccionNeurologica}
                cambiarEstado={setIdReaccionNeurologica}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Reacción Neurológica'}
                msg={"el formato no es valido"}
                lista={listaReaccionNeurologica}
                name={'id_reaccion_neurologica'}
                label={setReaccionNeurologica}
                importante={false}

              />
            </Col>

            <Col md={2}>
              <Select1
                estado={idReaccionHematologica}
                cambiarEstado={setIdReaccionHematologica}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Reacción Hematológica'}
                msg={"el formato no es valido"}
                lista={listaReaccionHematologica}
                name={'id_reaccion_hematologica'}
                label={setReaccionHematologica}
                importante={false}

              />
            </Col>
          </Row>

          <InputUsuarioXS
            estado={observacion}
            cambiarEstado={setObservacion}
            ExpresionRegular={INPUT.TEXT}
            etiqueta={'Observaciones:'}
            msg={"El formato no es válido"}
            name={'observaciones'}
            importante={false}
          />
          <p style={{ color: '#f5365c', fontSize: '11px' }}>
            Todo paciente con dos pruebas serológicas positivos se considera para hacer tratamiento
          </p>

          <div style={{ display: 'flex', justifyContent: 'center', padding: '1px 0px' }} >
            <div className="hero-section m-1 mt-3 mb-3" >
              <button onClick={() => insertar()} className="btn btn-success" >Registrar</button>
            </div>
          </div>
        </ModalBody>
      </Modal >




      <Modal
        isOpen={modalEdit}
        toggle={() => setModalEdit(!modalEdit)}
        className="modal-lgmd"
      >
        <ModalHeader
          toggle={() => setModalEdit(!modalEdit)}
        >
        </ModalHeader>
        <ModalBody>

          <CabeceraFormulariosTratamiento text={'MODIFICAR TRATAMIENTO'} />

          <div className='cabecera-form mt-3'  >
            <p>DATOS DEL PACIENTE</p>
          </div>
          <Row className='mb-3'>
            <Col md={4}>
              <Select1
                estado={idPaciente}
                cambiarEstado={setIdPaciente}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Paciente'}
                msg={"el formato no es valido"}
                lista={listaPacientes}
                name={'id_paciente'}
                label={setNombrePaciente}
                importante={false}
              />
            </Col>

            <Col md={3}>
              <FormGroup>
                <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                  {'Paciente'}
                </label>
                <Input
                  type="text"
                  value={listaPacientes.find(e => idPaciente.campo == e.value)?.label?.split('-')[0] || ""}
                  valido={null}
                  placeholder={'PACIENTE'}
                  toUpperCase
                  disabled
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                  {'Cédula de identidad'}
                </label>
                <Input
                  type="text"
                  value={listaPacientes.find(e => idPaciente.campo == e.value)?.ci || ""}
                  valido={null}
                  placeholder={'C.I.'}
                  toUpperCase
                  disabled
                />
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup>
                <label style={{ marginBottom: '0', fontSize: '11px', fontWeight: 'bold' }}>
                  {'fecha Nacimiento'}
                </label>
                <Input
                  type="text"
                  value={listaPacientes.find(e => idPaciente.campo == e.value)?.fecha_nac || ""}
                  valido={null}
                  placeholder={'FECHA NACIMIENTO'}
                  toUpperCase
                  disabled
                />
              </FormGroup>
            </Col>




          </ Row>


          <div className='cabecera-form mt-3'  >
            <p>RESULTADOS</p>
          </div>
          <Row>
          <Col md={4}>
              <Select1
                estado={epidemica}
                cambiarEstado={setEpidemica}
                name={'epidemica'}
                ExpresionRegular={INPUT.ID}
                lista={[ {value:1, label:'VIVIENDA NEGATIVA'}, {value:2, label:'VIVIENDA POSITIVA'} ]}
                etiqueta={'Situacion epidemica'}
                msg={"El formato no es válido"}
              />
            </Col>
            <Col md={4}>
              <Select1
                estado={rociado}
                cambiarEstado={setRociado}
                name={'rociado'}
                ExpresionRegular={INPUT.ID}
                lista={[ {value:1, label:'VIVIENDA ROCIADO'}, {value:2, label:'VIVIENDA NO ROCIADO'} ]}
                etiqueta={'Vivienda rociado'}
                msg={"El formato no es válido"}
              />
            </Col>

            <Col md={4}>
              <Select1Aux
                estado={idPostTratamiento}
                cambiarEstado={setIdPostTratamiento}
                ExpresionRegular={INPUT.ID}
                etiqueta={'PostTratamiento'}
                msg={"el formato no es valido"}
                lista={[{ value: 1, label: 'Si' }, { value: 2, label: 'No' }]}
                name={'id_post_tratamiento'}
                label={setPostTratamiento}
                importante={false}
              />
            </Col>
            <Col md={12}>
              <InputUsuario
                tipo='textarea'
                estado={complementarios}
                cambiarEstado={setComplementarios}
                name={'complementarios'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Resultados examenes complementarios'}
                msg={"El formato no es válido"}
                importante={false}
              />
            </Col>
          </Row>
          <div className='cabecera-form mt-3'  >
            <p>TRATAMIENTO</p>
          </div>

          <Row>
            <Col md={3}>
              <InputUsuario
                estado={peso}
                cambiarEstado={setPeso}
                name={'peso'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Peso (Kg.)'}
                msg={"El formato no es válido"}
              />
            </Col>
            <Col md={3}>
              <InputUsuario
                estado={ta}
                cambiarEstado={setTa}
                name={'presion_arterial'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'TA(mmHg)'}
                msg={"El formato no es válido"}
              />
            </Col>
            <Col md={3}>
              <InputUsuario
                estado={temperatura}
                cambiarEstado={setTemperatura}
                name={'temperatura'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Temperatura(°c)'}
                msg={"El formato no es válido"}
              />
            </Col>
            <Col md={3}>
              <InputUsuario
                estado={frecuencia}
                cambiarEstado={setFrecuencia}
                name={'frecuencia_cardiaca'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Frec. cardiaca(Ipm)'}
                msg={"El formato no es válido"}
              />
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Select1Aux
                estado={idMedicamento}
                name={'id_medicamento'}
                cambiarEstado={setIdMedicamento}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Medicamento'}
                lista={listaMedicamentos}
                msg={"el formato no es valido"}
                label={setMedicamento}
              />
            </Col>
            <Col md={3}>
              <InputUsuario
                estado={dosis}
                cambiarEstado={setDosis}
                name={'dosis'}
                ExpresionRegular={INPUT.TEXT}
                etiqueta={'Dosis Mg.'}
                msg={"El formato no es válido"}
              />
            </Col>

            <Col md={3}>
              <InputUsuario
                estado={fechaInicio}
                cambiarEstado={setFechaInicio}
                ExpresionRegular={INPUT.DATE} //expresion regular
                etiqueta={'Fecha inicio'}
                msg={"el formato no es valido"}
                name={'fecha_inicio'}
                tipo='date'
              />
            </Col>

            <Col md={3}>
              <InputUsuario
                estado={fechaConclusion}
                cambiarEstado={setFechaConclusion}
                ExpresionRegular={INPUT.DATE} //expresion regular
                etiqueta={'Fecha conclusion'}
                msg={"el formato no es valido"}
                name={'fecha_conclusion'}
                tipo='date'
                importante={false}
              />
            </Col>
          </Row>
          <Row>
            {/* <Col md={2}>
              <Select1
                estado={idMujeresTratamiento}
                cambiarEstado={setIdMujeresTratamiento}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Mujeres Tratamiento'}
                msg={"el formato no es valido"}
                lista={listaMujeresTratamiento}
                name={'id_mujer'}
                label={setMujeresTratamiento}
                importante={false}
              />
            </Col> */}
            <Col md={2}>
              <Select1
                estado={idSuspension}
                cambiarEstado={setIdSuspension}
                ExpresionRegular={INPUT.ID} //expresion regular
                etiqueta={'Suspension'}
                lista={listaSuspension}
                name={'idSuspension'}
                label={setSuspension}
                importante={false}
              />
            </Col>
            <Col md={2}>
              <Select1
                estado={idAbandono}
                cambiarEstado={setIdAbandono}
                ExpresionRegular={INPUT.ID} //expresion regular
                etiqueta={'Abandono'}
                lista={listaAbandono}
                msg={"el formato no es valido"}
                name={'idAbandono'}
                label={setAbandono}
                importante={false}
              />
            </Col>

            {/* <Col md={6}>
              <Select1
                estado={idEstadoMujeres}
                cambiarEstado={setIdEstadoMujeres}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Estado Mujeres'}
                msg={"el formato no es valido"}
                lista={[{ value: 1, label: 'GESTANTES SEROPOSITIVAS PARA CHAGAS DETECTADAS EN CONTROL PRE-NATAL' }]}
                name={'id_estado_mujeres'}
                label={setEstadoMujeres}
                importante={false}
              />
            </Col> */}


            {/* <Col md={4}>
              <Select1
                estado={idPreQuirurgico}
                cambiarEstado={setIdPreQuirurgico}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Prequirurgico'}
                msg={"el formato no es valido"}
                lista={[{ value: 1, label: 'Si' }, { value: 2, label: 'No' }]}
                name={'id_prequirurgico'}
                label={setPreQuirurgico}
                importante={false}
              />
            </Col> */}
            <Col md={4}>
              <Select1
                estado={idHospital}
                cambiarEstado={setIdHospital}
                ExpresionRegular={INPUT.ID} //expresion regular
                etiqueta={'Hospital de referencia'}
                lista={listaHospital}
                name={'hospital_ref'}
                label={setHospital}
                importante={false}
              />
            </Col>
          </Row>


          <div className='cabecera-form mt-3' >
            <p>REACCIONES ADVERSAS</p>
          </div>
          <Row className='mb-3'>
            <Col md={4}>
              <Select1
                estado={idReaccionDermatologica}
                cambiarEstado={setIdReaccionDermatologica}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Reacción Dermatológica'}
                msg={"el formato no es valido"}
                lista={listaReacionDermatologica}
                name={'id_reaccion_dermatologica'}
                label={setReaccionDermatologica}
                importante={false}

              />
            </Col>
            <Col md={3}>
              <Select1
                estado={idReaccionDigestiva}
                cambiarEstado={setIdReaccionDigestiva}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Reacción Digestiva'}
                lista={listaReaccionDigestiva}
                msg={"el formato no es valido"}
                name={'id_reaccion_digestiva'}
                label={setReaccionDigestiva}
                importante={false}

              />
            </Col>

            <Col md={3}>
              <Select1
                estado={idReaccionNeurologica}
                cambiarEstado={setIdReaccionNeurologica}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Reacción Neurológica'}
                msg={"el formato no es valido"}
                lista={listaReaccionNeurologica}
                name={'id_reaccion_neurologica'}
                label={setReaccionNeurologica}
                importante={false}

              />
            </Col>

            <Col md={2}>
              <Select1
                estado={idReaccionHematologica}
                cambiarEstado={setIdReaccionHematologica}
                ExpresionRegular={INPUT.ID}
                etiqueta={'Reacción Hematológica'}
                msg={"el formato no es valido"}
                lista={listaReaccionHematologica}
                name={'id_reaccion_hematologica'}
                label={setReaccionHematologica}
                importante={false}

              />
            </Col>
          </Row>
          <InputUsuarioXS
            estado={observacion}
            cambiarEstado={setObservacion}
            ExpresionRegular={INPUT.TEXT}
            etiqueta={'Observaciones:'}
            msg={"El formato no es válido"}
            name={'observaciones'}
            importante={false}
          />
          <p style={{ color: '#f5365c', fontSize: '11px' }}>
            Todo paciente con dos pruebas serológicas positivos se considera para hacer tratamiento
          </p>

          <div style={{ display: 'flex', justifyContent: 'center', padding: '1px 0px' }} >
            <div className="hero-section m-1 mt-3 mb-3" >
              <button onClick={() => editar()} className="btn btn-success" >Editar</button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </ >
  );
}

